<template>
	<modal-component
		v-if="dialogOpened"
		:onClose="onClose"
		:buttons="buttons"
		:deleteConfirm="deleteConfirm"
		:copyConfirm="copyConfirm"
		:nextConfirm="nextConfirm"
		:subscriptionDialogPause="subscriptionDialogPause"
		:subscriptionDialogCancel="subscriptionDialogCancel"
		:subscriptionDialogDowngrade="subscriptionDialogDowngrade"
		:subscriptionDialogUpgrade="subscriptionDialogUpgrade"
		:subscriptionDialogSwitchingPlansFailed="subscriptionDialogSwitchingPlansFailed"
		:removeItemFromBasket="removeItemFromBasket"
		:removeItemFromQuantity="removeItemFromQuantity"
		:isProtectOrderFlow="isProtectOrderFlow"
		:isSunsetShare="isSunsetShare"
		:classes="'modal-big popup-small'"
		:class="{'single-button': confirmOnly || closeOnly}"
		:showLogo="showLogo"
	>
		<div class="header-sales">
			<div class="carlsjr-shop-alert"></div>
			<template v-if="[2, 3, 5].includes(tenantId)">
				<v-icon>shopping_cart</v-icon>
				<h2>{{ header }}</h2>
			</template>
			<template v-else>
				<h2 v-bind:style="h2Style">{{ header }}</h2>
			</template>
		</div>
		<div class="text-sales"> {{ text }}</div>
	</modal-component>
</template>

<script>
	import ModalComponent from "./ModalComponent.vue";
	import appConfig from "../../appconfig";

	const tenantConfig = appConfig.tenantConfig;
	export default {
		name: "OrderPanelConfirmation",
		props: ["dialogOpened", "onConfirm", "onClose", "params", "header", "text", "deleteConfirm", "nextConfirm",
			"copyConfirm", "confirmOnly", "closeOnly", "customButtons", "subscriptionDialogPause","subscriptionDialogCancel",
			"subscriptionDialogDowngrade", "subscriptionDialogUpgrade", "subscriptionDialogSwitchingPlansFailed",
			"removeItemFromBasket", "removeItemFromQuantity", "isProtectOrderFlow", "isSunsetShare", "h2Style", "showLogo"
		],
		data(){
			return {
				tenantId: tenantConfig.tenantId
			};
		},
		components: {
			ModalComponent
		},
		computed: {
			buttons() {
				const self = this;
				if (self.customButtons) {
					return self.customButtons;
				} else {
					if(self.confirmOnly) {
						return {
							ok() {
								if(self.params) {
									self.onConfirm(...self.params);
								} else {
									self.onConfirm();
								}

								self.onClose();
							}
						};
					}
					if(self.closeOnly) {
						return {
							cancel() {
								self.onClose();
							}
						};
					}
					return {
						cancel() {
							self.onClose();
						},
						ok() {
							if(self.params) {
								self.onConfirm(...self.params);
							} else {
								self.onConfirm();
							}

							self.onClose();
						}
					};
				}
			}
		}
	};

</script>

<style lang="scss" scoped>
	.carlsjr-shop-alert {
		display: none;
	}
</style>
